module.exports = __webpack_public_path__ + "static/media/bandeira_brasil.6c5dedc7.png";